// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.annual-statements-table div.no-statements-message {
  white-space: nowrap;
  margin-left: 33%;
  margin-top: 10%;
  padding: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/RightsholderRoyaltiesAnnualStatements/RoyaltiesAnnualStatementsTable/index.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;AAAJ","sourcesContent":[".annual-statements-table {\n  div.no-statements-message {\n    white-space: nowrap;\n    margin-left: 33%;\n    margin-top: 10%;\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
